import { useContext } from "react";
import { ScreenWidthContext } from "../contexts/ScreenWidthContext";

export default function useScreenWidth() {
  return useContext(ScreenWidthContext);
}
